.root {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 16px 16px;
  text-align: center;
}

.check-badge {
  align-items: center;
  background: var(--color-success);
  border-radius: 50%;
  color: var(--color-primary-foreground, white);
  display: flex;
  height: 56px;
  justify-content: center;
  margin-bottom: 8px;
  width: 56px;
}

.footer {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-top: 12px;
  width: 100%;
}
